<template>
  <HeadingWrapper
    v-if="'no-wrapper' in $parent.$attrs || noWrapper"
    :smaller-title="'smaller-title' in $parent.$attrs || smallerTitle"
    v-bind="$props"
  >
    <template v-slot:title>
      <slot name="title" />
    </template>
    <slot />
  </HeadingWrapper>

  <PopoutWrapper
    v-else-if="popout"
    v-bind="$props"
    :flag="getFlag"
    @ok="$emit('ok', $event)"
    @cancel="$emit('cancel', $event)"
    @show="$emit('show', $event)"
  >
    <template v-slot:title>
      <slot name="title" />
    </template>
    <slot />
  </PopoutWrapper>

  <CollapseWrapper
    v-else
    v-bind="$props"
  >
    <template v-slot:title>
      <slot name="title" />
    </template>
    <slot />
  </CollapseWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import CollapseWrapper from '@/components/builder/UI/CollapseWrapper.vue'
import HeadingWrapper from '@/components/builder/UI/HeadingWrapper.vue'
import PopoutWrapper from '@/components/builder/UI/PopoutWrapper.vue'
import wrapperProps from '@/components/builder/UI/wrapperProps'

const components = {
  CollapseWrapper,
  HeadingWrapper,
  PopoutWrapper,
}

const props = {
  ...wrapperProps,
  popout: Boolean,
  flag: Boolean,
}

@Component({ components })
export default class BuilderWrapper extends Vue.extend({ props }) {
  get getFlag () {
    return this.title === 'Bar Chart'
  }
}

</script>
